var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import assertNever from 'assert-never';
import isIExpected from './isIExpected';
import isIStatement from './isIStatement';
import Expected from './Expected';
import Statement from './Statement';
export function discourseFactory(discourse, convertor) {
    if (isIExpected(discourse)) {
        const {type} = discourse, rest = __rest(discourse, ['type']);
        return new Expected(Object.assign({}, rest, { factory: convertor }));
    } else if (isIStatement(discourse)) {
        const {type} = discourse, rest = __rest(discourse, ['type']);
        return new Statement(Object.assign({}, rest, { factory: convertor }));
    } else {
        return assertNever(discourse);
    }
}
export {
    discourseFactory as factory
};
export default discourseFactory;    //# sourceMappingURL=factory.js.map
